// extracted by mini-css-extract-plugin
export default {"policy":"Privacy_policy__1a6t7","big_title":"Privacy_big_title__SgDLa","title":"Privacy_title__uTSZM","text":"Privacy_text__HMkH8"};